import React, { useState } from "react";
import { Field, Form, Formik } from "formik";
import NumericField from "components/Form/NumericField";
import IconLoader from "components/IconLoader/IconLoader";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import apiCall from "services/apiCall";
import { getSessionInfoByIdentityNumber } from "services/exam/session-service";
import showToast from "helpers/showToast";
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
// import { validateCaptchaToken } from "services/captcha-service";

const validationSchema = Yup.object().shape({
  identityNumber: Yup.string().min(11, "11 karakter olmalıdır!").required("FORM.REQUIRED")
});

function IdentityCheck({ setApplicationList, setIdentityNumber, changeMultiplePageMode }) {
  // const { executeRecaptcha } = useGoogleReCaptcha();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    let captchaValid = true;
    // if (process.env.NODE_ENV === "production") {
    //   const token = await executeRecaptcha();
    //   const captchaRes = await apiCall({
    //     service: validateCaptchaToken,
    //     serviceParams: token || " "
    //   });
    //   captchaValid = captchaRes?.data === true;
    // }
    if (captchaValid) {
      setIdentityNumber(values?.identityNumber);
      apiCall({
        service: getSessionInfoByIdentityNumber,
        serviceParams: values?.identityNumber,
        onSuccess: (res) => {
          setApplicationList(res?.data || []);
          const modeList = [
            { name: "registerForm", open: false },
            { name: "identityCheck", open: false },
            { name: "validEntry", open: false },
            { name: "applicationList", open: false },
            { name: "registerMenu", open: true }
          ];
          changeMultiplePageMode(modeList)();
        },
        onError: () => {
          setLoading(false);
          setApplicationList([]);
          showToast("TC sorgulama işlemi sırasında hata oluştu.", { type: "error" });
        }
      });
    } else {
      showToast("Bir hata oluştu.", { type: "error" });
      setLoading(false);
    }
  };
  return (
    <div className="container pt-6" style={{ position: "relative" }}>
      <button
        onClick={() => navigate(-1)}
        className="btn btn-primary d-none d-lg-block"
        style={{ position: "absolute", left: -85 }}
      >
        <IconLoader icon="mdiChevronLeft" size={1} />
      </button>
      <div className="w-100 d-flex justify-content-center">
        <img src="/media/register/registerTitleImage.png" style={{ maxWidth: "100%" }} />
      </div>
      <Formik
        initialValues={{ identityNumber: "" }}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {({ values, setFieldValue }) => (
          <Form className="mx-auto my-10">
            <div className="row d-flex flex-column align-items-center justify-content-center">
              <div className="col-lg-4">
                <Field
                  name="identityNumber"
                  label="Öğrenci Tc Kimlik No"
                  placeholder="IDINFORMATION.ID"
                  component={NumericField}
                  maxLength={11}
                  classes="text-center"
                />
              </div>
              <div className="col-lg-4">
                <button
                  className={`btn btn-primary btn-block ${
                    loading ? "spinner spinner-white spinner-left" : ""
                  }`}
                  type={"submit"}
                  disabled={loading}
                >
                  Başvuru Yap / Sonuç Görüntüle
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      <div
        className="d-flex justify-content-center mt-2 align-items-center"
        style={{ height: "150px", fontSize: "20px", fontWeight: "bold" }}
      >
        <a
          href={"/media/register/sinavYonerge.jpeg"}
          target="_blank"
          rel="noreferrer"
          className="my-2"
        >
          Bursluluk Sınav Yönergesi
        </a>
      </div>
      {/* <div className="d-flex justify-content-center mt-4">
        <img src="/media/register/sinavYonerge.jpeg" style={{ maxWidth: "60%" }} />
      </div> */}
    </div>
  );
}

export default IdentityCheck;
